import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ToBeImplemented from "../pages/ToBeImplemented";
import FrontPage from "../pages/FrontPage";
import SelectProductRange from "../pages/SelectProductRange";
import SelectModel from "../pages/SelectModel";
import AddDocument from "../pages/AddDocument";
import ProtectedRoute from "./ProtectedRoute";
import SelectDocument from "../pages/SelectDocument";
import EditDocument from "../pages/EditDocument";
import ExcludeSerialNumber from "../pages/ExcludeSerialNumber";
import DeleteDocument from "../pages/DeleteDocument";
import ChangeApplicability from "../pages/ChangeApplicability";

const modelPaths = ["/SelectModel", "/SelectProductRange/SelectModel"];
const selectDocumentPaths = [
  "/SearchSerialNumber",
  "/SearchDocument",
  "/SelectModel/ViewDocuments",
  "/SelectProductRange/SelectModel/ViewDocuments",
  "/SelectProductRange/ViewDocuments",
];
const AddDocumentPaths = [
  "/SelectModel/AddDocument",
  "/SelectProductRange/SelectModel/AddDocument",
  "/SearchSerialNumber/AddDocument",
];
const EditDocumentPaths = [
  "/SearchSerialNumber/EditDocument",
  "/SearchDocument/EditDocument",
  "/SelectModel/ViewDocuments/EditDocument",
  "/SelectProductRange/SelectModel/ViewDocuments/EditDocument",
  "/SelectProductRange/ViewDocuments/EditDocument",
];

const ExcludeSerialNumberPaths = [
  "/SearchSerialNumber/ExcludeSerialNumber",
  "/SearchDocument/ExcludeSerialNumber",
  "/SelectModel/ViewDocuments/ExcludeSerialNumber",
  "/SelectProductRange/SelectModel/ViewDocuments/ExcludeSerialNumber",
  "/SelectProductRange/ViewDocuments/ExcludeSerialNumber",
];

const DeleteDocumentPaths = [
  "/SearchSerialNumber/DeleteDocument",
  "/SearchDocument/DeleteDocument",
  "/SelectModel/ViewDocuments/DeleteDocument",
  "/SelectProductRange/SelectModel/ViewDocuments/DeleteDocument",
  "/SelectProductRange/ViewDocuments/DeleteDocument",
];

const ChangeApplicabilityLevelPaths = [
  "/SearchSerialNumber/ChangeApplicabilityLevel",
  "/SearchDocument/ChangeApplicabilityLevel",
  "/SelectModel/ViewDocuments/ChangeApplicabilityLevel",
  "/SelectProductRange/SelectModel/ViewDocuments/ChangeApplicabilityLevel",
  "/SelectProductRange/ViewDocuments/ChangeApplicabilityLevel",
];
export default function RoutePages() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FrontPage />} />
        {modelPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"modelState"}>
                <SelectModel />
              </ProtectedRoute>
            }
          />
        ))}

        <Route
          path="/SelectProductRange"
          element={
            <ProtectedRoute state={"productRangeState"}>
              <SelectProductRange />
            </ProtectedRoute>
          }
        />

        {selectDocumentPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"selectDocumentState"}>
                <SelectDocument />
              </ProtectedRoute>
            }
          />
        ))}

        {AddDocumentPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"addDocumentState"}>
                <AddDocument />
              </ProtectedRoute>
            }
          />
        ))}

        {EditDocumentPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"editDocumentState"}>
                <EditDocument />
              </ProtectedRoute>
            }
          />
        ))}

        {ExcludeSerialNumberPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"excludeSerialNumberState"}>
                <ExcludeSerialNumber />
              </ProtectedRoute>
            }
          />
        ))}

        {DeleteDocumentPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"deleteDocumentState"}>
                <DeleteDocument />
              </ProtectedRoute>
            }
          />
        ))}

        {ChangeApplicabilityLevelPaths.map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute state={"changeApplicabilityState"}>
                <ChangeApplicability />
              </ProtectedRoute>
            }
          />
        ))}
        <Route path="*" element={<ToBeImplemented />} />
      </Routes>
    </Router>
  );
}
